import { request } from './peticion.js';

export interface AdminUser {
  pk: string;
  cognitoSub?: string;
  email: string;
  assignedRoles?: string[];
  tenantScope?: string[];
  createdAt?: string;
}

/**
 * Roles preset (ADR-016). Van en el frontend a propósito: son un conjunto
 * fijo, no un catálogo editable, y no existe endpoint de roles.
 */
export const PRESET_ROLES = [
  {
    id: 'tenant_admin',
    label: 'Administrador del tenant',
    hint: 'Opera su tenant completo y gestiona a su equipo',
  },
  {
    id: 'operator',
    label: 'Operador',
    hint: 'Atiende conversaciones y corrige datos de contacto',
  },
  { id: 'viewer', label: 'Solo lectura', hint: 'Consulta sin poder modificar nada' },
] as const;

export const usersApi = {
  list: () => request<{ users: AdminUser[] }>('/admin/users'),
  create: (body: {
    email: string;
    assignedRoles: string[];
    tenantScope: string[];
  }) =>
    request<{ cognitoSub: string; email: string }>('/admin/users', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
};
